/* eslint-disable prettier/prettier */
export const styles = {
  fixedTable: {
    tableLayout: 'fixed',
  },
  searchWrapper: {
    width: { xs: 160, sm: 220, md: 320 },
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      height: '46px',
      alignItems: 'center',
      paddingRight: 0,
      marginTop: 0,
    },
    '& .MuiOutlinedInput-input': {
      padding: '6px 10px',
      height: '34px',
      boxSizing: 'border-box',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
    },
  },
  searchBoxContainer: {
    mr: 1,
  },
};
